import { DisplayVM } from './DisplayVM';

/**
 * @deprecated
 * 请使用 `DisplayVM` 实现
 */
export class DescVM extends DisplayVM {}
